module.exports = __webpack_public_path__ + "img/HE7102-163.8a161530.jpg";